<template>
  <BaseGlobalLoader v-if="isLoaded"/>
  <router-view :key="company" v-else/>
  <component :is="'script'" :src="MEET_BASE_API_URL" async></component>
</template>


<script setup>
import 'nprogress/nprogress.css'
import '../public/assets/css/nprogress.custom.css'
import BaseGlobalLoader from '@/components/BaseGlobalLoader'
import {computed} from 'vue';
import {useStore} from "vuex";
import { useRoute } from 'vue-router';
import {MEET_BASE_API_URL} from "@/services/meetService";

const store = useStore()
const isLoaded = computed(()=> store.getters['isAppLoaded'])
const company = computed(() => store.getters['offices/getSelectCompanyId'])

const route = useRoute();

</script>
<style scoped>
.loader-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.scroll-y {
  overflow-y: scroll;
  overflow-x: hidden;
  position: relative;
}


</style>
